import { render, staticRenderFns } from "./ModalInsert.vue?vue&type=template&id=6499d47b"
import script from "./ModalInsert.vue?vue&type=script&lang=js"
export * from "./ModalInsert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports